import { Autocomplete, Button, Field, SearchField } from 'components/commons';
import React, { useCallback } from 'react';
import styles from './transaction-filter.module.scss';
import DateRange from 'components/commons/date-range/date-range';
import { Path } from 'enums';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const TransactionFilter = ({
  role,
  filterState,
  onSearchChange,
  onSearch,
  onDateRangeChange,
  onPrintPassbook,
  onDownloadFile,
  fetchingReport,
  customer,
  onStatusChange,
  product
}) => {
  const history = useHistory();

  const onDateRangeChangeCb = useCallback(
    (name, { value, dirty }) => {
      if (onDateRangeChange) return onDateRangeChange(value, dirty);
    },
    [onDateRangeChange]
  );

  const onSearchChangeCb = useCallback(
    (name, { value }) => {
      if (onSearchChange) {
        return onSearchChange('searchKey', { value });
      }
    },
    [onSearchChange]
  );

  const onSearchCb = useCallback(
    (searchKey) => {
      if (onSearch) {
        return onSearch(searchKey);
      }
    },
    [onSearch]
  );

  const onStatusChangeCb = useCallback(
    (name, { value }) => {
      if (onStatusChange) return onStatusChange(value || 'all');
    },
    [onStatusChange]
  );

  return (
    <div className={styles.filter}>
      <div className={styles.filterContent}>
        <Field className={styles.date} label={'Date'}>
          <DateRange
            value={{
              startDate: filterState.startDate,
              endDate: filterState.endDate
            }}
            onChange={onDateRangeChangeCb}
          />
        </Field>

        {['admin', 'approver', 'super-admin'].includes(role) && (
          <Field className={styles.status} label="Status">
            <Autocomplete
              name="status"
              value={filterState.status}
              options={[
                { label: 'Success', value: 'success' },
                { label: 'Voided', value: 'voided' },
                { label: 'Pending', value: 'pending' },
                { label: 'Rejected', value: 'rejected' }
              ]}
              onChange={onStatusChangeCb}
            />
          </Field>
        )}

        <Field className={styles.search} label="Search">
          <SearchField
            placeholder={'Account Number, Transaction ID'}
            value={filterState.searchKey}
            onChange={onSearchChangeCb}
            onEnter={onSearchCb}
            restrict={false}
          />
        </Field>
      </div>
      {['savings', 'shared-capital'].includes(product) && customer && (
        <Field className={styles.downloadButton}>
          <Button exportButton onClick={onPrintPassbook}>
            Print Passbook
          </Button>
        </Field>
      )}
      {!customer && (
        <Field className={styles.downloadButton}>
          <Button exportButton onClick={onDownloadFile} loading={fetchingReport}>
            Generate Report
          </Button>
        </Field>
      )}

      <Field>
        <Button
          className={styles.transactionsButton}
          onClick={() => {
            history.push(`${Path.Transaction}/report/${product}`);
          }}
        >
          Back to Customer Accounts
        </Button>
      </Field>
    </div>
  );
};

export default TransactionFilter;
